// Core
import React from "react";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

//Import Scss
import "./styles.scss";
//Import assets
import assets from "../../../Assets";

//Import Custom Components
import NormalTable from "Components/Common/Table";
import Pagination from "Components/Pagination";
import DatePicker from "../../Common/DatePicker";
import DropDownBox from "Components/Common/DropDownBox";

//Import NPM Components
import "react-datepicker/dist/react-datepicker.css";

//redux
import { useDispatch } from "react-redux";
import { fetchCreditReqList } from "../../../Redux/Slices/requestManagementSlice";
import { fetchUserManagementCompany } from "../../../Redux/Slices/userManagementSlice";

const CreditRequest = () => {
  const headerDetails = [
    {
      label: "S No",
      sortKey: false,
      singleClickFunc: () => { },
    },
    {
      label: "Users Name",
      sortKey: true,
      singleClickFunc: () => {
        setSortOptions({
          sort_by: !sortOptions.sort_by,
          order_by: "firstname",
        });
      },
    },
    {
      label: "Mobile Number",
      sortKey: true,
      singleClickFunc: () => {
        setSortOptions({
          sort_by: !sortOptions.sort_by,
          order_by: "mobile_number",
        });
      },
    },
    {
      label: "Plan Requested",
      sortKey: true,
      singleClickFunc: () => {
        setSortOptions({
          sort_by: !sortOptions.sort_by,
          order_by: "no_of_credits",
        });
      },
    },
    {
      label: "Request Submitted on",
      sortKey: true,
      singleClickFunc: () => {
        setSortOptions({
          sort_by: !sortOptions.sort_by,
          order_by: "request_submitted_on",
        });
      },
    },
    {
      label: "Action",
      sortKey: false,
    },
  ];

  const [company, setCompany] = useState(null);

  const [companyList, setCompanyList] = useState([]);

  // const handleChange = (selectedOption) => {
  //   setSelectedOption(selectedOption);
  // };
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [creditReqList, setCreditReqList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [sortOptions, setSortOptions] = useState({
    sort_by: false,
    order_by: "createdAt",
  });
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [isLoading, setIsLoading] = useState(false)

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleFromDate = (date) => {
    // if (date) {
    setFromDate(date ? new Date(date) : null);
    if (toDate && date && toDate < date) {
      setToDate(null);
    }
    // } else {
    //   setFromDate(null); 
    // }
  };
  const handleToDate = (date) => {
    setToDate(date ? new Date(date) : null);
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);

    // Extract day, month, and year
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
    const year = date.getFullYear();

    // Extract hours and minutes
    // let hours = date.getHours();
    // const minutes = String(date.getMinutes()).padStart(2, "0");

    // Determine AM/PM and format hours
    // const ampm = hours >= 12 ? "PM" : "AM";
    // hours = hours % 12 || 12;

    // Format the date and time
    return `${day}/${month}/${year}`;
  };

  function formatSendDate(dateString) {
    if (dateString === "") {
      return "";
    }
    const date = new Date(dateString);

    // Extract year, month, and day
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
    const day = String(date.getDate()).padStart(2, "0");

    // Format the date as YYYY-MM-DD
    const formattedDate = `${year}-${month}-${day}`;

    // Prevent sending "1970-01-01"
    return formattedDate === "1970-01-01" ? null : formattedDate;
  }

  const getInitials = (name) => {
    const [firstName = "", lastName = ""] = name.split(" ");
    return (
      (firstName[0] || "").toUpperCase() + (lastName[0] || "").toUpperCase()
    );
  };

  useEffect(() => {
    setIsLoading(true)
    dispatch(
      fetchUserManagementCompany({
        callBack: (value) => {
          // console.log(value.data)
          //add laabel and value for dropdown options
          const updatedCategories = value.data.map((item) => ({
            ...item,
            label: item.company_name,
            value: item.company_id,
          }));
          const additionalObject = {
            label: 'All Companies',
            value: '',
            company_name: 'All Companies'
          };
          setCompanyList([additionalObject, ...updatedCategories])
        },
      })
    );
    dispatch(
      fetchCreditReqList({
        data: {
          page: currentPage,
          limit: "10",
          sort_by: sortOptions.sort_by ? "ASC" : "DESC",
          order_by: sortOptions.order_by,
          fromDate: formatSendDate(fromDate) || "",
          ...(formatSendDate(toDate) && { toDate: formatSendDate(toDate) }),
          company_id: company?.company_id || "",
        },
        callBack: (value) => {
          console.log(value);
          setCreditReqList(value.data.data_list || value.data);
          setTotalPages(value.data.pageMeta.totalPages || 1);
          setTotalCount(value?.data?.pageMeta?.total || 0);
          setIsLoading(false)
        },
      })
    );
  }, [sortOptions, currentPage, company, fromDate, toDate]);

  return (
    <div className="creditRequestContainer">
      <div className="creditRequestHeader">
        <p>Purchase Request</p>

        <div className="creditReqDatePicker">
          <p className="totalCount">
  Total count : {totalCount}
</p>
          <DropDownBox
            options={companyList}
            placeholder="Company Name"
            onChange={(option) => {
              setCompany(option);
              setCurrentPage(1);
            }}
            value={company}
            customStyles={{
              control: (provided) => ({
                ...provided,
                border: '0px',
                borderBottom: '1px solid grey',
                borderRadius: '0',
                width: '180px',
                boxShadow: 'none',
                padding: '5px 3px',
                fontFamily: 'Poppins',
                marginRight: '20px',
                fontSize: '14px',
                height: "50px",
              }),
              indicatorSeparator: () => ({ display: 'none' }),
              menu: (provided) => ({
                ...provided,
                fontFamily: 'Poppins',
                fontSize: '14px',
              }),
              option: (provided, state) => ({
                ...provided,
                fontFamily: 'Poppins',
                fontSize: '14px',
                backgroundColor: state.isFocused ? '#f1f1f1' : 'white',
                color: state.isFocused ? 'black' : 'grey',
                cursor: 'pointer',
              }),
            }}
          />
          <DatePicker
            placeholderText="From Date"
            selected={fromDate}
            onChange={handleFromDate}
            format={"dd-MM-yyyy"}
          />
          <DatePicker
            placeholderText="To Date"
            selected={toDate}
            minDate={fromDate}
            onChange={handleToDate}
            format={"dd-MM-yyyy"}
          />
        </div>
      </div>
      <div className="creditReqTableContainer">
        <NormalTable
          headerDetails={headerDetails}
        // pagination={true}
        >
          {creditReqList.length > 0
            ? creditReqList.map((list, index) => {
              return (
                <>
                  <tr className="border" key={list.credit_history_id}>
                    <td
                      style={{
                        paddingLeft: "18px",
                      }}
                    >
                      {(currentPage - 1) * 10 + (index + 1)}
                    </td>
                    <td>
                      <div
                        style={{
                          display: "flex",
                          gap: "3px",
                          alignItems: "center",
                        }}
                      >
                        {" "}
                        {list?.user_details?.firstname ? (
                          <div
                            style={{
                              height: "30px",
                              width: "30px",
                              backgroundColor: "#1E2156",
                              borderRadius: "50%",
                              color: "white",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            {getInitials(list?.user_details?.firstname)}
                          </div>
                        ) : (
                          ""
                        )}
                        <p>{list?.user_details?.firstname || "-"}</p>
                      </div>
                    </td>
                    <td>{list?.user_details?.country_code} {list?.user_details?.mobile}</td>
                    <td>{list.no_of_credits}</td>
                    <td>{formatDate(list?.createdAt)}</td>
                    <td>
                      <button
                        onClick={() =>
                          navigate(
                            `/request/creditRequestDetails/${list.credits_request_id}`
                          )
                        }
                        className="creditRequestViewButton"
                      >
                        View Details
                      </button>
                    </td>
                  </tr>
                </>
              );
            })
            : " "}
        </NormalTable>
        {creditReqList.length > 0 ? '' : <p style={{ textAlign: 'center', fontFamily: 'poppins', fontSize: "4vh" }}>{isLoading ? "Loading" : "No Data Found"} </p>}
        {creditReqList.length > 0 ?
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={handlePageChange}
          /> : " "}
      </div>
    </div>
  );
};

export default CreditRequest;
